import ListingVM from './listing-vm';
export default {
  init: function(){
    console.log('Initializing Kadenze.AdminCourseListing');

    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    };

    var courses_data = JSON.parse($('#courses_json').val());
    courses_data.selectedCategoryId = $('#js-selected-category').val();
    ko.applyBindingsWithValidation(new ListingVM(courses_data, 'AdminCourseListing'), document.getElementById('admin_course_listing'), validationOptions);
  }
};

